import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TitleSecondary } from '../../components';

import styles from './clients.module.scss';

const ClientInformation = ({ clientInformation }) => {
  return (
    <div className={styles.clientInfoContainer}>
      <TitleSecondary>Nustatymai</TitleSecondary>
      <div className={styles.clientInfoContent}>
        {clientInformation.map(({ title, value }, index) => (
          <div key={index} className={styles.clientInfoInner}>
            <span className={styles.clientInfoTitle}>{title}</span>
            <span className={styles.clientInfoValue}>{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

ClientInformation.propTypes = {
  clientInformation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default connect()(ClientInformation);
